import { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { Eraser } from "lucide-react";
import { useTranslationApp } from "../../../../lib/i18next";
import { CanvasToolsBarButton } from "../../../Editor/CanvasToolsBar";
import {
  CANVAS_TOOL_ERASER,
  CANVAS_TOOL_ERASER_BRUSH_SIZE,
  CANVAS_TOOL_ERASER_HINT,
} from "../../../../i18n/keysTranslations";
import {
  OBJECT_ERASER_BRUSH_FRACTION_MAX,
  OBJECT_ERASER_BRUSH_FRACTION_MIN,
} from "./ObjectEraserOverlay";

const ObjectEraserTool = ({
  active = false,
  brushFraction,
  disabled = false,
  loading = false,
  onToggle = () => {},
  onBrushFractionChange = () => {},
}) => {
  const { t } = useTranslationApp();
  const anchorRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const onSliderChange = (_event, value) => {
    onBrushFractionChange(Array.isArray(value) ? value[0] : value);
  };

  const onClickToggle = (event) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
    onToggle();
  };

  return (
    <>
      <Box ref={anchorRef} sx={{ display: "inline-flex" }}>
        <CanvasToolsBarButton
          icon={Eraser}
          label={t(CANVAS_TOOL_ERASER)}
          showLabel
          active={active}
          disabled={disabled}
          loading={loading}
          onClick={onClickToggle}
        />
      </Box>
      <Popper
        open={active}
        anchorEl={anchorEl || anchorRef.current}
        placement="bottom"
        modifiers={[
          {
            name: "offset",
            options: { offset: [0, 10] },
          },
        ]}
        sx={{ zIndex: 1400 }}
      >
        <Paper
          elevation={0}
          onPointerDown={(event) => event.stopPropagation()}
          sx={{
            width: 252,
            px: 1.5,
            py: 1.25,
            border: "1px solid #D4D4D8",
            borderRadius: "12px",
            bgcolor: "#fff",
            boxShadow: "0 8px 24px rgba(24,24,27,0.12)",
          }}
        >
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              color: "#18181B",
              lineHeight: 1.35,
              mb: 1.25,
            }}
          >
            {t(CANVAS_TOOL_ERASER_HINT)}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 600,
              color: "#71717A",
              mb: 0.25,
            }}
          >
            {t(CANVAS_TOOL_ERASER_BRUSH_SIZE)}
          </Typography>
          <Slider
            size="small"
            min={OBJECT_ERASER_BRUSH_FRACTION_MIN}
            max={OBJECT_ERASER_BRUSH_FRACTION_MAX}
            step={0.01}
            value={brushFraction}
            disabled={disabled}
            onChange={onSliderChange}
            aria-label={t(CANVAS_TOOL_ERASER_BRUSH_SIZE)}
            sx={{
              color: "#18181B",
              py: 0.5,
              "& .MuiSlider-thumb": {
                width: 14,
                height: 14,
              },
            }}
          />
        </Paper>
      </Popper>
    </>
  );
};

export default ObjectEraserTool;
